module.exports = __webpack_public_path__ + "media/images/flavours/icon-fleur_dark-cf701d7a02dc0450751342b5f7a50738.png";